<style lang="scss" src='./StationDetails.scss' scoped ></style>
<template src="./StationDetails.html"></template>

<script>
import { mapState } from 'vuex';
import CommonComponent from '@/components/utils/CommonComponent.vue';
import StationMap from '@/views/station/details/active/map/StationMap.vue';
import StationAlerts from '@/views/station/details/active/alerts/StationAlerts.vue';
import StationChart from '@/views/station/details/active/chart/StationChart.vue';
import StationData from '@/views/station/details/active/data/StationData.vue';

export default {
  name: 'StationDetails',
  extends: CommonComponent,
  components: {
      StationMap,
      StationAlerts,
      StationChart,
      StationData,
  },
  data() {
    return ({
      tabIdxSelected: 0,
      tabs:  [
        {title: this.$t('sensors.data'), component: 'StationData', icon: 'ico_data'},
        {title: this.$t('alerts.alerts'), component: 'StationAlerts', icon: 'ico_alerts'},
        {title: this.$t('sensors.map'), component: 'StationMap', icon: 'ico_location'},
        {title: this.$t('sensors.charts'), component: 'StationChart', icon: 'ico_chart'},
      ],
    });
  },
  computed: {
    ...mapState({
      station: (state) => state.station,
    }),
  },

  methods: {
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.setShowMenu(false);
    this.setShowBackground(false);
  },
};
</script>
